/**
 * A FELÜLET IKONJAI — vonalas, 24-es rácson, `currentColor`-ral.
 *
 * A SZÍN A SZÜLŐTŐL JÖN, nem innen: egy ikon soha nem hordoz saját színt,
 * tehát a tokenszabály (`docs/design-tokens.md`) itt magától teljesül. A
 * rajzok Ákos demójából valók (`docs/tervezes/demo-regi.html`, `ICONS`).
 *
 * MIND DÍSZ, és ezért `aria-hidden`. Mindegyik mellett ott áll a felirat; a
 * képernyőolvasónak egy „kamera" szó a „Lefotózom" előtt csak zaj.
 */

import type { ReactNode } from 'react';

function Icon({ children }: { children: ReactNode }) {
  return (
    <svg
      className="icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export function CameraIcon() {
  return (
    <Icon>
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </Icon>
  );
}

export function FileIcon() {
  return (
    <Icon>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
    </Icon>
  );
}

export function ImageIcon() {
  return (
    <Icon>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="M21 15l-5-5L5 21" />
    </Icon>
  );
}

/**
 * A SZEM — a jelszó megjelenítésének jele. Az admin `Eye`-jának rajza
 * (`admin-node-vite-react/src/components/common/Eye.tsx`). Az ÁTHÚZOTT szem
 * azt mutatja, mi TÖRTÉNIK a kattintásra: a jelszó elrejtése.
 */
export function EyeIcon({ off }: { off: boolean }) {
  return (
    <Icon>
      <path d="M3 12c2.4-4 5.4-6 9-6s6.6 2 9 6c-2.4 4-5.4 6-9 6s-6.6-2-9-6z" />
      <circle cx="12" cy="12" r="2.5" />
      {off ? <path d="M4 4l16 16" /> : null}
    </Icon>
  );
}

export function UploadIcon() {
  return (
    <Icon>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <path d="M17 8l-5-5-5 5" />
      <path d="M12 3v12" />
    </Icon>
  );
}
